import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const storeUser = (u) => localStorage.setItem("ha_user", JSON.stringify(u));
export const readUser = () => { try { return JSON.parse(localStorage.getItem("ha_user") || "null"); } catch { return null; } };
export const clearUser = () => localStorage.removeItem("ha_user");
export const fmt = (n, decimals = 2) => Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
export const errMsg = (error) => {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) {
    const messages = detail.map((item) => item?.msg || item?.message || String(item)).filter(Boolean);
    return messages.join(", ") || "Please check the submitted information.";
  }
  if (detail && typeof detail === "object") {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  return String(detail || error?.message || "Something went wrong.");
};
// Package images live behind our backend. If image_url already starts with http,
// use it as-is; otherwise prefix the configured backend host.
export const imgSrc = (url) => {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  return `${process.env.REACT_APP_BACKEND_URL}${url.startsWith("/") ? url : "/" + url}`;
};
